<!-- Breadcrumb -->
<div
    class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between"
>
    <h5 class="mb-0">
        {{'User_Groups' | translate}}
    </h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            {{'Users' | translate}}
        </li>
        <li class="breadcrumb-item position-relative">
            {{'User_Groups' | translate}}
        </li>
    </ol>
</div>

<mat-card
    class="daxa-card users-card mb-25 border-radius border-none d-block bg-white"
>
    <mat-card-header>
        <mat-card-title>
            {{'User_Groups' | translate }}
        </mat-card-title>
        <mat-card-subtitle>
            <a
                mat-button
                class="add-new-btn"
                routerLink="/users/add-user-group"
            >
                + {{'Add New User Group' | translate}}
            </a>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="row mb-25">
            @if(isLoading()){
                <div class="spiner">
                    <app-buffer-progress-bar></app-buffer-progress-bar>
                </div>
            }
            @for (userGroup of userGroups; track $index) {
            <div class="col-md-6">
                <div class="user-group">
                    <span>{{ userGroup.id }} - {{ userGroup.title }}</span>
                    <div class="user-group-actions">
                        <button
                            mat-button
                            class="daxa edit-user-group"
                            [routerLink]="[
                                '/users/edit-user-group',
                                userGroup.id
                            ]"
                        >
                            <i class="ri-edit-line"></i>{{'Edit' | translate}}
                        </button>
                        <mat-slide-toggle 
                            [checked]="!userGroup.disabled"
                            (change)="onToggle($event, userGroup)"
                            matTooltip="{{userGroup.disabled? 'Enable' : 'Disable'}}"
                            matTooltipPosition="above"
                        >
                        </mat-slide-toggle>
                    </div>
                </div>
            </div>
            }
        </div>
    </mat-card-content>
</mat-card>
